module.exports = __webpack_public_path__ + "img/chinesecompany150.03ed8144.png";